/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Modal, CircularProgress } from '@mui/material';

export default function SpinnerModal({ open }) {
  return (
    <Modal
      open={open}
      css={css`
        display: flex;
        align-items: center;
        justify-content: center;
      `}
    >
      <CircularProgress
        size={150}
        thickness={4}
        css={css`
          outline: none;
        `}
      />
    </Modal>
  );
}
